import React from 'react'
import  Header from '../../components/Header' 
import { DatosGenerales, Finalidades, Transferencia, DatosArco, MediosCookies } from './components'
import  Footer from '../../components/Footer'
import '../../styles/pages/aviso.css'

const HomeAviso = () => {
	return (
		<React.Fragment>
			<Header />
            <DatosGenerales />
			<Finalidades />
			<Transferencia />
			<DatosArco />
			<MediosCookies />
			<Footer />
		</React.Fragment>
	)
}

export default HomeAviso
